<template>
    <div class="form-field form-color-picker" v-bind:class="{'form-required': requiredForm, 'form-focus': focus}">
        <div class="form-label" v-if="label">
            <label>{{ label }}</label>
        </div>
        <div class="form-input">
            <div class="form-input-wrapper" ref="colorpicker">
                <input type="text"
                       v-model="internalValue"
                       @focus="showPicker()"
                       @input="updateFromInput"
                       @blur="focus=false"/>
                <span class="color" v-bind:style="{background:internalValue}" @click="togglePicker()"></span>
                <chrome-picker :value="colors" @input="updateFromPicker" v-if="displayPicker"/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['value','label','required','default'],
        data() {
            return {
                colors: {
                    hex: '#000000',
                },
                internalValue: '',
                displayPicker: false,
                focus: false
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.requiredForm = this.required && (this.required == 'true' || this.required == true) ? true : false
            this.setDefault(this.internalValue || this.default);
        },
        methods: {
            setDefault(color) {
                this.updateColors(color);
                this.internalValue = color;
            },
            updateColors(color) {
                if( color )
                {
                    if(color.substr(0, 1) == '#') {
                        this.colors = {
                            hex: color
                        };
                    }
                    else if(color.substr(0, 4) == 'rgba') {
                        var rgba = color.replace(/^rgba?\(|\s+|\)$/g,'').split(','),
                            hex = '#' + ((1 << 24) + (parseInt(rgba[0]) << 16) + (parseInt(rgba[1]) << 8) + parseInt(rgba[2])).toString(16).slice(1);
                        this.colors = {
                            hex: hex,
                            a: rgba[3],
                        }
                    }
                }
            },
            showPicker() {
                this.focus = true;
                document.addEventListener('click', this.documentClick);
                this.displayPicker = true;
            },
            hidePicker() {
                document.removeEventListener('click', this.documentClick);
                this.displayPicker = false;
            },
            togglePicker() {
                this.displayPicker ? this.hidePicker() : this.showPicker();
            },
            updateFromInput() {
                this.updateColors(this.internalValue);
            },
            updateFromPicker(color) {
                this.colors = color;
                if(color.rgba.a == 1) {
                    this.internalValue = color.hex;
                }
                else {
                    this.internalValue = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')';
                }
            },
            documentClick(e) {
                var el = this.$refs.colorpicker,
                    target = e.target;
                if(el !== target && !el.contains(target)) {
                    this.hidePicker()
                }
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            },
            'default'(newVal, oldVal) {
                this.setDefault(newVal);
            },
            'internalValue'(newVal, oldVal) {
                this.updateColors(newVal);
                this.$emit('input', this.internalValue);
                if( this.onChange ){
                    this.callback(this.internalValue)
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/ColorPicker.vue